import { useSnapshotSidebarItems } from '_/components/Snapshots/useSnapshotSidebarItems';
import { useSidebar, CONTEXT_DEPTH } from '_/contexts/LayoutContext';
import { SnapshotProvider, useSnapshotContext } from '_/contexts/SnapshotContext';
import React, { ReactNode, useEffect } from 'react';

interface SnapshotSectionProps {
  children: ReactNode;
}

/**
 * Sidebar manager that consumes SnapshotContext
 * Separated from provider to avoid circular dependency
 */
function SnapshotSidebarManager({ children }: SnapshotSectionProps) {
  const { snapshotId } = useSnapshotContext();
  const { setSidebarItems, registerContext, unregisterContext } = useSidebar();
  const sidebarItems = useSnapshotSidebarItems();

  useEffect(() => {
    registerContext(CONTEXT_DEPTH.SNAPSHOT);
    return () => {
      unregisterContext(CONTEXT_DEPTH.SNAPSHOT);
    };
  }, [registerContext, unregisterContext]);

  useEffect(() => {
    if (snapshotId && sidebarItems.length > 0) {
      setSidebarItems(sidebarItems, CONTEXT_DEPTH.SNAPSHOT);
    }
  }, [setSidebarItems, sidebarItems, snapshotId]);

  return <>{children}</>;
}

/**
 * SnapshotSection - Wrapper for snapshot-level pages
 * Combines provider and sidebar manager
 */
function SnapshotSection({ children }: SnapshotSectionProps) {
  return (
    <SnapshotProvider>
      <SnapshotSidebarManager>{children}</SnapshotSidebarManager>
    </SnapshotProvider>
  );
}

export default SnapshotSection;
